export const DEFAULT_PREMADE_TEMPLATE_NAME = 'Premade design'
export const DEFAULT_CUSTOM_TEMPLATE_NAME = 'Your custom template'
export const SINCLIAR_ORG_CODE_PRIVACY_TEXT = 'SBGI.NET/PRIVACY-POLICY'
